// import contribuyentes from "../../assets/static/images/secciones/contribuyentes.png";
// import contribuyente from "../../assets/static/images/secciones/contribuyente.png";
// import inmuebles from "../../assets/static/images/secciones/inmuebles.png";
// import condiciones from "../../assets/static/images/secciones/condicioneslegales.png";
import gestion from "../../assets/static/images/secciones/gestionlegal.png";
// import planDePago from "../../assets/static/images/secciones/plandepagos.png";
// import comercios from "../../assets/static/images/secciones/comercios.png";
import convenios from "../../assets/static/images/secciones/convenios.png";
import abogados from "../../assets/static/images/secciones/abogados.png";
import bandejaentrada from "../../assets/static/images/secciones/bandejaentrada.png";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TooltipText from "../../components/TooltipText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardCheck, faCog, } from "@fortawesome/free-solid-svg-icons";
// import { faClipboardCheck, faCog, faTasks, } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";
import { mesasEntradaActions } from "../../redux/MesasEntrada/actions";
import "./Home.css";

const Home = () => {
  const { user } = useSelector((state) => state.authentication);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mesasEntradaActions.limpiarMesas());
  }, []);

  const menus = [
    {
      name: "abogado-externo",
      path: "abogado-externo",
      title: "Búsqueda de Contribuyentes",
      img: gestion,
      show: (user.rol !== "guest"),
      text: "Búsqueda de Contribuyentes"
    },
    {
      name: "mesa-extrajudicial",
      path: "mesa-extrajudicial",
      title: "Mesa de entradas extrajudicial",
      img: bandejaentrada,
      show: true,
      text: "Mesa de entradas extrajudicial"
    },
    {
      name: "mesa-judicial",
      path: "mesa-judicial",
      title: "Mesa de entradas judicial",
      img: bandejaentrada,
      show: true,
      text: "Mesa de entradas judicial"
    },
    // {
    //   name: "contribuyentes",
    //   path: "contribuyentes",
    //   title: "Contribuyentes",
    //   img: contribuyentes,
    //   opacity: true,
    //   show: true,
    //   text: "Permite consultar ( no modificar) los datos sobre el contribuyente que tiene RAFAM."
    // },
    // {
    //   name: "novedades",
    //   path: "novedades",
    //   title: "Novedades",
    //   img: contribuyente,
    //   show: true,
    //   text: "Permite visualizar los datos tanto del inmueble como del contribuyente distintos a los de RAFAM."
    // },
    // {
    //   name: "inmuebles",
    //   path: "inmuebles",
    //   title: "Inmuebles",
    //   img: inmuebles,
    //   show: true,
    //   text: "Es una ventana de consulta, permite una búsqueda partiendo del dato de un inmueble."
    // },
    // {
    //   name: "comercios",
    //   path: "comercios",
    //   title: "Comercios",
    //   img: comercios,
    //   opacity: true,
    //   show: true,
    //   text: "Es una ventana de consulta, permite buscar comercios partiendo del dato de un inmueble."
    // },
    {
      name: "datos",
      path: "mis-datos",
      title: "Mis datos",
      img: abogados,
      show: (user.rol === "user" && user.rol !== "guest"),
      text: "Datos del abogado externo."
    },
    {
      name: "abogados",
      path: "abogados",
      title: "Abogados",
      img: abogados,
      show: (user.rol === "admin" || user.abogado === "A00"),
      text: "Es un listado de los abogados que actualmente trabajan como apoderados externos."
    },
    {
      name: "scoring-abogados",
      path: "scoring-abogados",
      title: "Scoring abogados",
      icon: faClipboardCheck,
      show: user.dni === "28978423" || user.dni === "40763199" || user.dni === "30293450",
      text: "Scoring abogados externos."
    },
    // {
    //   name: "condiciones",
    //   path: "condiciones",
    //   title: "Condiciones Legales",
    //   img: condiciones,
    //   show: (user.rol === "admin" || user.abogado === "A00"),
    //   text: "Convenios firmados entre apoderados y municipio y sus respectivos poderes."
    // },
    // {
    //   name: "gestion",
    //   path: "gestion",
    //   title: "Gestión Legal",
    //   img: gestion,
    //   show: true,
    //   text: "Ventana en la cual el apoderado carga los movimientos de la causa."
    // },
    {
      name: "convenios",
      path: "convenios",
      title: "Convenios",
      img: convenios,
      show: true,
      text: "Permite generar convenio de pago de honorarios y reconocimiento de deudas."
    },
    // {
    //   name: "planDePago",
    //   path: "planes-de-pago",
    //   title: "Plan de pagos",
    //   img: planDePago,
    //   show: true,
    //   text: "Permite ver el estado actual de los planes de pago."
    // },
    // {
    //   name: "comunicaciones",
    //   path: "comunicaciones",
    //   title: "Comunicaciones",
    //   icon: faTasks,
    //   show: (user.rol !== "guest"),
    //   text: "Comunicaciones."
    // },
    // {
    //   name: "registros",
    //   path: "registros",
    //   title: "Registros",
    //   icon: faTasks,
    //   show: true,
    //   text: "Ver Registros."
    // },
    {
      name: "creaciontitulos",
      path: "creaciontitulos",
      title: "Creación Títulos",
      icon: faClipboardCheck,
      show: ((user.rol === "admin" || user.abogado === "A00") && user.rol !== "guest"),
      text: "Creación Títulos."
    },
    {
      name: "registroslogin",
      path: "RegistrosLogin",
      title: "Registros Login",
      icon: faClipboardCheck,
      show: user.dni === "32097070" || user.dni === "39548852",
      text: "Registros Login."
    },
    {
      name: "configuracion",
      path: "configuracion",
      title: "Configuración",
      icon: faCog,
      show: ((user.rol === "admin" || user.abogado === "A00") && user.rol !== "guest"),
      text: "Ver Configuración."
    },
    // {
    //   name: "historial",
    //   path: "historial",
    //   title: "Historial",
    //   icon: faFolderOpen,
    //   show: (user.rol === "admin" || user.abogado === "A00"),
    //   text: "Ver Historial de acciones."
    // },
  ];

  return (
    <>
      <div className="home">
        <div className="home-row" style={{ marginTop: 50, padding: 50 }}>
          {menus.map((e) => {
            return e.show ? (
              <TooltipText
                key={e.name}
                placement={"top"}
                text={e.text}
              >
                <Link to={`/${e.path}`} key={e.name}>
                  <div className="home-section">
                    <div className="home-subtitle">
                      <span>{e.title}</span>
                    </div>
                    <div>
                      {e.icon ? (
                        <FontAwesomeIcon icon={e.icon} style={{ fontSize: 44, color: "#999999" }} />
                      ) : (
                        <img src={e.img} alt={e.name} className={e.opacity ? "opacity-icon" : ""} style={{ width: 54 }} />
                      )}
                    </div>
                  </div>
                </Link>
              </TooltipText>
            ) : null;
          })}
        </div>
      </div>
    </>
  );
};

export default Home;
